import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Card, CardContent, Grid, TextField, Typography, Container, CssBaseline, InputLabel, styled, IconButton } from "@material-ui/core";
import CachedIcon from "@mui/icons-material/Cached";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Toast } from "@egovernments/digit-ui-react-components";
import { TLService } from "../../../../../../libraries/src/services/elements/TL";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-input": { padding: "10px 15px" },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    backgroundImage: 'url("https://t3.ftcdn.net/jpg/02/99/39/50/360_F_299395041_SEg76lLpIaGAPRjI3uPqIdd3nm3ecRpv.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    objectFit: "cover",
    imageRendering: "auto",
    opacity: ".85",
    // backgroundColor:'#fff',
  },
  overlay: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)", // Adjust the opacity (last value) as needed
  },
  card: {
    padding: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    border: "2px 0px 2px 2px",
    width: "370px",
    backgroundSize: "",
  },
  logo: {
    width: "110px",
    height: "85px",
  },
  header: {
    marginBottom: "10px",
    textDecoration: "none",
  },
  textField: {
    marginBottom: "10px",
  },
  button: {
    marginTop: "20px",
    width: "223px",
    height: "35px",
    borderRadius: "1px",
  },
}));

const EmployeeLoginCard = () => {
  const classes = useStyles();
  const tenantId = Digit.ULBService.getStateId();
  const setEmployeeDetail = (userObject, token) => {
    let locale = JSON.parse(sessionStorage.getItem("Digit.locale"))?.value || "en_IN";
    localStorage.setItem("Employee.tenant-id", userObject?.tenantId);
    localStorage.setItem("tenant-id", userObject?.tenantId);
    localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
    localStorage.setItem("locale", locale);
    localStorage.setItem("Employee.locale", locale);
    localStorage.setItem("token", token);
    localStorage.setItem("Employee.token", token);
    localStorage.setItem("user-info", JSON.stringify(userObject));
    localStorage.setItem("Employee.user-info", JSON.stringify(userObject));
  };
  const { data: storeData, isLoading: isStoreLoading } = Digit.Hooks.useStore.getInitData();
  const { stateInfo } = storeData || {};
  const { register, handleSubmit, watch } = useForm();
  const [user, setUser] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [disable, setDisable] = useState(true);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  const history = useHistory();

  useEffect(() => {
    if (!user) {
      return;
    }
    Digit.SessionStorage.set("citizen.userRequestObject", user);
    const filteredRoles = user?.info?.roles?.filter((role) => role.tenantId === Digit.SessionStorage.get("Employee.tenantId"));
    if (user?.info?.roles?.length > 0) user.info.roles = filteredRoles;
    Digit.UserService.setUser(user);
    setEmployeeDetail(user?.info, user?.access_token);
    let redirectPath = "/digit-ui/employee";

    if (window?.location?.href?.includes("from=")) {
      redirectPath = decodeURIComponent(window?.location?.href?.split("from=")?.[1]) || "/digit-ui/employee";
    }

    if (user?.info?.roles && user?.info?.roles?.every((e) => e.code === "NATADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    }

    if (user?.info?.roles && user?.info?.roles?.every((e) => e.code === "STADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/home";
    }

    history.replace(redirectPath);
  }, [user]);

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (captcha === captchaInput) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [captcha, captchaInput]);

  const generateCaptcha = () => {
    const randomCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(randomCaptcha);
    setCaptchaInput("");
  };
  const trackEscalteApplication = async () => {
    const result = await TLService.workflowEsclate();
  };
  useEffect(() => {
    trackEscalteApplication();
  }, []);

  const onLogin = async (data) => {
    if (captcha !== captchaInput) {
      setShowToast({ error: true, message: `Invalid CAPTCHA` });
      setTimeout(closeToast, 5000);
      return;
    }

    setDisable(true);
    const requestData = {
      username: data?.username,
      password: data?.password,
      userType: "EMPLOYEE",
    };
    requestData.tenantId = tenantId;
    delete requestData.city;
    try {
      const { UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
      Digit.SessionStorage.set("Employee.tenantId", info?.tenantId);
      setUser({ info, ...tokens });
    } catch (err) {
      setShowToast({ error: true, message: `Invalid Login Credential` });
      setTimeout(closeToast, 5000);
    }
    setDisable(false);
  };

  const closeToast = () => {
    setShowToast(null);
  };

  const onForgotPassword = () => {
    history.push("/digit-ui/employee/user/forgot-password");
  };

  return (
    <div className={classes.root}>
      <Container component="main" maxWidth="xs">
        <Card className={classes.card}>
          <CssBaseline />
          <CardContent>
            <Grid container justifyContent="center" alignItems="center" spacing={2}>
              <Grid item>
                <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" alt="Logo" className={classes.logo} />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  component="h6"
                  align="center"
                  style={{ fontWeight: "600", fontFamily: "sans-serif", lineHeight: "24px", letterSpacing: ".5px" }}
                  className={classes.header}
                >
                  EMPLOYEE LOGIN
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <InputLabel>Employee ID</InputLabel>
                <StyledTextField
                  {...register("username", { required: true })}
                  margin="normal"
                  variant="outlined"
                  required
                  fullWidth
                  id="username"
                  label=""
                  name="username"
                  placeholder="Enter Employee ID"
                  autoFocus
                  className={classes.textField}
                  autoComplete="off"
                />
              </Grid>
              {/* Password TextField */}
              <Grid item xs={12}>
                <InputLabel htmlFor="password">Password</InputLabel>
                <StyledTextField
                  {...register("password", { required: true })}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  placeholder="Enter Password"
                  label=""
                  type="password"
                  id="password"
                  autoComplete="off"
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={12} container alignItems="center">
                <StyledTextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="captcha"
                  placeholder="Enter CAPTCHA"
                  autoComplete="off"
                  name="captcha"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  inputProps={{ maxLength: 4 }}
                />
                <InputLabel>
                  CAPTCHA: <span style={{ fontStyle: "italic", fontSize: "16px" }}>{captcha}</span>
                  <IconButton>
                    <CachedIcon onClick={generateCaptcha} />
                  </IconButton>
                </InputLabel>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={handleSubmit(onLogin)}
                  disabled={disable}
                >
                  Continue
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Typography component="div" align="center" onClick={onForgotPassword} style={{ cursor: "pointer", color: "#303F9F" }}>
                  Forgot Password?
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

      {showToast && <Toast error={showToast?.error} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDleteBtn={true} />}
    </div>
  );
};

export default EmployeeLoginCard;
